'use strict';

module.exports = function (sdk, config) {
    /**
     * 打开View时，触发
     * @method hysdk.onShow
     * @category Fusion:WebView Event
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    /**
     * 数据回溯时，触发
     * @method hysdk.onReceiveData
     * @category Fusion:WebView Event
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    sdk.bridge.on('web_view_did_appear', function (param) {
        sdk.ctrip.trigger('show');
        var data = void 0;
        try {
            data = JSON.parse(param.callbackString);
        } catch (e) {
            config.debug && console.warn('[HySDK] callbackString canot be parse :' + param.callbackString);
        }
        if (data) {
            sdk.ctrip.trigger('receiveData', data);
        }
    });
    sdk.bridge.on('web_view_finished_load', function () {
        sdk.ctrip.trigger('show');
    });
    /**
     * 监听导航条的点击事件
     * @method hysdk.onNavClick
     * @category Fusion:Navigation Event
     * @description
     * 支持 title 和 right，并且在调用了 navRefresh 后可用
     */
    sdk.bridge.on('title_click', function () {
        sdk.ctrip.trigger('navClick', {
            button: 'title'
        }, function () {});
    });
    sdk.bridge.on('right', function () {
        sdk.ctrip.trigger('navClick', {
            button: 'right'
        }, function () {});
    });
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/lib/events.js
// module id = 56
// module chunks = 1 4